@if (text && !!text.length) {
  <div class="description">
    <h2>{{ header | hisUi }}</h2>
    <em>
      @if (!hisobject || !hisAttribute) {
        <div>
          <!-- show the shortened text -->
          @if (!showFullText && isMaxTextLength()) {
            <span class="wordBreak">{{getMaxTextLength(text)}}</span>
          }
          <!-- show text in full length -->
          @if (showFullText || !isMaxTextLength()) {
            <span class="wordBreak">{{text}}</span>
          }
        </div>
      }
      @if (hisobject && hisAttribute) {
        <div>
          <!-- show the shortened text -->
          @if (!showFullText && isMaxTextLength()) {
            <his-translated-text [hisobject]="hisobject" [hisAttribute]="hisAttribute" [maxLength]="maxLength"></his-translated-text>
          }
          <!-- show text in full length -->
          @if (showFullText || !isMaxTextLength()) {
            <his-translated-text [hisobject]="hisobject" [hisAttribute]="hisAttribute"></his-translated-text><br/>
          }
        </div>
      }
      <!-- Only show buttons to open/close if text is longer than the preset maximum length -->
      @if (isMaxTextLength()) {
        @if (!showFullText) {
          <button (click)="setShowFullText(true)" class="icon" hisImage="ARROW_DOWN_V" title="{{ expandToolTip | hisUi }}"></button>
        }
        @if (showFullText) {
          <button (click)="setShowFullText(false)" class="icon" hisImage="ARROW_UP_V" title="{{ collapseToolTip | hisUi }}"></button>
        }
      }
    </em>
  </div>
}